module.exports = __webpack_public_path__ + "static/img/ios_ru.4b5b3371.png";